import { render, staticRenderFns } from "./SaleTypes.vue?vue&type=template&id=50687c71"
import script from "./SaleTypes.vue?vue&type=script&lang=js"
export * from "./SaleTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports